<aw-add-sim-to-box [box]="data" (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)"></aw-add-sim-to-box>